import React from 'react';
import { useIntl } from 'react-intl';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import { StyledBox } from './styles/Box';

function SectionKnowMore() {
  const { formatMessage } = useIntl();

  return (
    <StyledBox
      tag="section"
      paddingVertical={{ xs: '12x' }}
      paddingHorizontal={{ xs: '6x', md: '12x' }}
      minHeight={{ lg: '90vh' }}
      display={{ lg: 'flex' }}
      alignItems={{ lg: 'center' }}
    >
      <Grid
        row
        justify={{ md: 'flex-end', lg: 'flex-start' }}
        spacing="0"
      >
        <Grid
          col={{ xs: 12, md: 6, lg: 3 }}
          offset={{ lg: 8 }}
        >
          <Box
            backgroundColor="white.default"
            padding={{ xs: '6x', md: '8x' }}
            marginTop={{ xs: '16.5rem', md: '38rem', lg: 0 }}
            borderRadius={{ md: '1.25rem' }}
          >
            <Typography
              variant="title"
              tag="h3"
              gutterBottom={{ xs: 3 }}
              intlKey="INSURANCE.KNOW_MORE.TITLE"
            />
            <Link
              variant="action"
              href={formatMessage({ id: 'INSURANCE.KNOW_MORE.LINK.URL' })}
              intlKey="INSURANCE.KNOW_MORE.LINK"
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
}

export default React.memo(SectionKnowMore);
